module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0120.2f8ce080.jpg";